<template>
  <div class="xscontainer jsjiesh">
    <div class="kkkdsf">
      <div class="left">
        <h class="mytitle">数据质量(含主数据)课程·线下学习</h>
        <img class="meme" src="@/assets/xxkc/zs.png"  />
      </div>
      <div class="right">
        <h class="hhm">数据质量实战管理能力认证课程【团体培训】</h>
        <h class="success-message">报名成功！</h>
        <p class="jinru">可进入<a href="#">【个人中心】</a>查看报名信息。</p>
        <div class="action-buttons">
          <button class="button-not-now">暂不缴费</button>
          <button class="button-pay-now">现在缴费</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataQualityCertificationPage'
}
</script>

<style scoped>
.kkkdsf {
  display: flex;
  gap: 3rem;
  align-items: end;
}
.left {
  display: flex;
  text-align: left;
  flex-direction: column;
  justify-content: space-around;
}
.mytitle{
  margin: 10px 0 30px;
  font-size: 22px;
  letter-spacing: 4px;
  font-weight: bold;
}
.meme {
  width: 40rem;
  height: 25rem;
}
.right {
  display: flex;
  flex-direction: column;
  gap:35px;
}
.hhm{
  font-weight: bold;
  font-size: 18px;
  color: #a9a8a8;
  letter-spacing: 2px;
}
.notification-section p {
  font-size: 14px;
  color: #333;
}

.success-message {
  font-size: 50px;
  color: #1e90ff;
}

.action-buttons {
  display: flex;
  justify-content: start;
  gap: 1rem;
}

.button-not-now, .button-pay-now {
  padding: 7px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  width: 160px;
}

.button-not-now {
  background-color: #f9f9f9;
  color: #333;
  margin-right: 20px;
}

.button-pay-now {
  background-color: #1e90ff;
  color: #fff;
}

a {
  color: #1e90ff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
